import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import HoverTooltip from '@Components/HoverTooltip';
import { withRouter } from 'react-router-dom';
import Catalyst from '@Services/Catalyst';

function Alerts() {
  const handleHelpClick = (e) => {
    Catalyst.trackContentLinkClick('header:icon:alerts');
    history.push(paths.ALERTS);
    e.stopPropagation();
  };

  return (
    <li className="u-els-padding-left-1o2 u-els-padding-bottom-1o8 u-els-display-none@tablet">
      <HoverTooltip id="alerts-tooltip" tooltip="Alerts" tooltipPlace="bottom-end" theme="simple">
        <ButtonWithIcon
          data-e2e="header-alerts"
          type="borderless"
          iconOnly
          sprite="Alarm"
          onClick={handleHelpClick}
          a11y={{ name: 'alerts' }}
          id="alerts-icon"
          active={history.location.pathname.indexOf('alerts') >= 0}>
          Alerts
        </ButtonWithIcon>
      </HoverTooltip>
    </li>
  );
}

export default withRouter(Alerts);
